'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$41() {
  this.bik = null;
  this.bil = false;
}
export { $c_Lpresto_PrestoRouter$$anon$41 as $c_Lpresto_PrestoRouter$$anon$41 };
$p = $c_Lpresto_PrestoRouter$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$41;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$41() {
}
export { $h_Lpresto_PrestoRouter$$anon$41 as $h_Lpresto_PrestoRouter$$anon$41 };
$h_Lpresto_PrestoRouter$$anon$41.prototype = $p;
$p.bW = (function() {
  if ((!this.bil)) {
    this.bik = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bil = true;
  }
  return this.bik;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$41, "presto.PrestoRouter$$anon$41", ({
  O8: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$41 as $d_Lpresto_PrestoRouter$$anon$41 };
//# sourceMappingURL=presto.-Presto-Router$$anon$41.js.map
